@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.banners

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.banners.BannerDto

object GetActiveBannersEndpoint : EndPoint<GetActiveBannersEndpoint.Request, GetActiveBannersEndpoint.Response>() {
    class Request

    class Response(
        val list: Array<BannerDto>
    )
}